import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import statusOptions from "containers/request/RequestList/statusOptions";
import RenderOptions from "containers/request/RequestList/RenderOptions";
import ModalConfirm from "components/ModalConfirm/index";
import ListRow from "components/request/ListRow";
import ErrorMsg from "components/ErrorMsg";
import { Pager, PagerPageSize, PagerStatusFilter, Divider } from "ctia-ui";
import { Col, Label, Table } from "react-bootstrap";
import { getRequestStatusGroup, needHideActions } from "helpers/RequestHelper";
import { fetchCertificationRequests, clearRequests } from "actions/requests";
import { startPreloader, finishPreloader } from "actions/preloader";
import { withdrawRequest, unwithdrawRequest } from "actions/request";
import { showNotice } from "actions/notifier";
import { notifyMessages } from "helpers/NotifyHelper";

class RequestList extends Component {
  constructor(props) {
    super(props);

    this.startPage = 1;
    this.initialStatus = 1;
    this.state = {
      status: this.initialStatus,
      showWithdrawConfirm: false,
      showUnwithdrawConfirm: false,
      requestData: null,
      isLoading: false,
      statusFilter: getRequestStatusGroup(this.initialStatus),
      pageSize: 100,
      isFormValid: true
    };
  }

  componentDidMount() {
    this.getRequests(this.startPage);
  }

  componentWillUnmount() {
    this.props.clearRequests();
  }

  onStatusChange = event => {
    const newStatus = Number(event.target.value);
    const statusFilter = getRequestStatusGroup(newStatus);

    this.setState({
      [event.target.id]: newStatus,
      statusFilter
    });

    // fetch new list
    this.getRequests(this.startPage, statusFilter);
  };

  onChangePageSize = size => {
    const pageSize = Number(size);

    this.setState({ pageSize });

    // fetch new list
    this.getRequests(this.startPage, this.state.statusFilter, pageSize);
  };

  getRequests = (
    pageNum,
    statusFilter = this.state.statusFilter,
    pageSize = this.state.pageSize
  ) => {
    const {
      startPreloader,
      fetchCertificationRequests,
      finishPreloader
    } = this.props;

    startPreloader().then(
      fetchCertificationRequests(pageNum, pageSize, statusFilter)
        .then(finishPreloader)
        .catch(finishPreloader)
    );
  };

  onWithdraw = id => {
    // withdraw reason
    const reason = document.getElementById("reasonRef").value;

    if (reason.length < 5) {
      this.setState({ isFormValid: false });
    } else {
      this.setState({ isLoading: true });
      this.props
        .withdrawRequest(id, reason)
        .then(this.clearAndFetch)
        .then(this.onCloseConfirm)
        .then(
          this.props.showNotice(notifyMessages.requestWithdrawnSuccessfully)
        )
        .catch(err =>
          this.props.showNotice(notifyMessages.cantWithdrawRequest)
        );
    }
  };

  onUnwithdraw = id => {
    this.setState({ isLoading: true });
    this.props
      .unwithdrawRequest(id, 1) // TODO: replace `1` with real prevrequeststatusid
      .then(this.clearAndFetch)
      .then(this.onCloseConfirm)
      .then(
        this.props.showNotice(notifyMessages.requestUnwithdrawnSuccessfully)
      )
      .catch(err =>
        this.props.showNotice(notifyMessages.cantUnwithdrawRequest)
      );
  };

  openWithdrawConfirm = requestData => {
    this.setState({
      showWithdrawConfirm: true,
      showUnwithdrawConfirm: false,
      requestData
    });
  };

  openUnwithdrawConfirm = requestData => {
    this.setState({
      showUnwithdrawConfirm: true,
      showWithdrawConfirm: false,
      requestData
    });
  };

  clearAndFetch = () => {
    this.props.clearRequests();
    this.getRequests(this.startPage);
  };

  onCloseConfirm = () => {
    this.setState({
      showWithdrawConfirm: false,
      showUnwithdrawConfirm: false,
      requestData: null,
      isLoading: false
    });
  };

  onValidate = value => {
    this.setState({ isFormValid: value.length > 4 });
  };

  render() {
    const { user, requests, history } = this.props;

    if (_.isNull(requests) || _.isUndefined(requests.list)) {
      return null;
    }

    if (requests.fetchError) {
      return <ErrorMsg error={requests.fetchError} history={history} />;
    }

    const tableData = requests.list;
    const isCTIAStaffUser = user.ctiaStaff;
    const {
      CURRENTPAGE: page,
      TOTALPAGES: pages,
      TOTALRECORDS: total
    } = requests.pages;

    const renderActionIconsHeader = () => {
      if (!isCTIAStaffUser) return null;
      if (needHideActions(tableData)) return null;

      return <th style={{ width: 40 }} />;
    };

    return (
      <div>
        <h1>
          Certification Requests{" "}
          <Label>{statusOptions[this.state.status].title}</Label>
        </h1>
        <div id="request-filter">
          <Col xs={6} />
          <Col xs={2}>
            <b>Total records:</b> {total}
          </Col>
          <Col xs={2}>
            <PagerPageSize
              size={this.state.pageSize}
              onChangeHandler={this.onChangePageSize}
              options={[25, 50, 100]}
            />
          </Col>
          <Col xs={2}>
            <PagerStatusFilter
              status={this.state.status}
              statusOptions={<RenderOptions />}
              onStatusChange={this.onStatusChange}
            />
          </Col>
        </div>
        <Table striped condensed hover>
          <thead>
            <tr>
              {renderActionIconsHeader()}
              <th>Request Id</th>
              {user.isStaff && <th>Manufacturer</th>}
              <th>Model Name / Number</th>
              <th>Device Type</th>
              <th>Request Type</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <ListRow
              tableData={tableData}
              isStaffUser={user.isStaff}
              isVendorUser={user.isVendor}
              isCTIAStaffUser={isCTIAStaffUser}
              openWithdrawConfirm={this.openWithdrawConfirm}
              openUnwithdrawConfirm={this.openUnwithdrawConfirm}
            />
          </tbody>
        </Table>
        <Divider show={pages > 1} />
        <Pager moveTo={this.getRequests} totalPages={pages} page={page} />
        <ModalConfirm
          type="withdrawReason"
          show={this.state.showWithdrawConfirm}
          onHide={this.onCloseConfirm}
          onHandle={() => this.onWithdraw(this.state.requestData.id)}
          requestData={this.state.requestData}
          isLoading={this.state.isLoading}
          isFormValid={this.state.isFormValid}
          onValidate={this.onValidate}
        />
        <ModalConfirm
          type="unwithdraw"
          show={this.state.showUnwithdrawConfirm}
          onHide={this.onCloseConfirm}
          onHandle={() => this.onUnwithdraw(this.state.requestData.id)}
          requestData={this.state.requestData}
          isLoading={this.state.isLoading}
        />
      </div>
    );
  }
}

function mapStateToProps({ requests, user }) {
  return { requests, user };
}

export default connect(mapStateToProps, {
  fetchCertificationRequests,
  clearRequests,
  startPreloader,
  finishPreloader,
  withdrawRequest,
  unwithdrawRequest,
  showNotice
})(RequestList);



// WEBPACK FOOTER //
// ./src/containers/request/RequestList/index.js